import React from 'react';
import thumb from '../../assets/images/about.png';

function About({ className }) {
    return (
        <section className={`moelist-traffic-area pt-140 pb-180 ${className || ''}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="moelist-traffic-title">
                            <span>About</span>
                            <h3 className="title">About the app</h3>
                            <p>
                                MoeList is an unofficial Android MyAnimeList client, with this app
                                you can easily track, rate, organize and discover new Anime & Manga.
                            </p>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="moelist-traffic-service mb-30">
                                    <div className="icon">
                                        <i className="fal fa-check" />
                                    </div>
                                    <h5 className="title">Material Design</h5>
                                    <p>
                                        The design of the app is based on Material Design guidelines
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="moelist-traffic-service item-2 mb-30">
                                    <div className="icon">
                                        <i className="fal fa-check" />
                                    </div>
                                    <h5 className="title">Written in Kotlin</h5>
                                    <p>
                                        MoeList was written with the programming language: Kotlin.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="moelist-traffic-service item-3">
                                    <div className="icon">
                                        <i className="fal fa-check" />
                                    </div>
                                    <h5 className="title">Official MAL API</h5>
                                    <p>MoeList uses the Official API of MyAnimeList.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="moelist-traffic-service item-4">
                                    <div className="icon">
                                        <i className="fal fa-check" />
                                    </div>
                                    <h5 className="title">50,000+ downloads</h5>
                                    <p>MoeList has more than 50,000 downloads on Play Store.</p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="traffic-btn mt-50">
                                    <a
                                        rel="noreferrer"
                                        href="https://github.com/axiel7/MoeList"
                                        target="_blank"
                                        className="main-btn"
                                    >
                                        GitHub <i className="fal fa-arrow-right" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="traffic-thumb ">
                <img
                    className="wow animated fadeInRight rounded-corners"
                    data-wow-duration="2000ms"
                    data-wow-delay="200ms"
                    src={thumb}
                    alt=""
                />
            </div>
        </section>
    );
}

export default About;
